import { useLocation, useNavigate } from "react-router-dom";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

function adminSelectValue(pathname: string): string {
  if (pathname === "/admin/overview" || pathname === "/admin/ops-health") return "/admin";
  if (pathname === "/admin/filters") return "/admin/report";
  if (
    pathname === "/admin/payroll" ||
    pathname === "/admin/touch-detail" ||
    pathname === "/admin/accounting" ||
    pathname === "/admin/reports"
  ) {
    return "/admin/exports";
  }
  return pathname;
}

export function AdminSubNav({
  canViewReports,
  canViewFieldNotesAdmin,
  canCreateOnBehalf,
  isAdmin,
}: {
  canViewReports: boolean;
  canViewFieldNotesAdmin: boolean;
  canCreateOnBehalf: boolean;
  isAdmin: boolean;
}) {
  const pathname = useLocation().pathname;
  const navigate = useNavigate();

  return (
    <Select value={adminSelectValue(pathname)} onValueChange={(v) => navigate(v)}>
      <SelectTrigger className="h-10 w-full max-w-md">
        <SelectValue placeholder="Admin section" />
        <SelectContent>
          {canViewReports && <SelectItem value="/admin">Overview</SelectItem>}
          {canViewReports && <SelectItem value="/admin/report">Admin Report</SelectItem>}
          {canViewReports && <SelectItem value="/admin/pay-period-reviews">Pay period reviews</SelectItem>}
          {canViewFieldNotesAdmin && <SelectItem value="/admin/field-notes">Field Notes</SelectItem>}
          {canCreateOnBehalf && <SelectItem value="/admin/on-behalf">Create Punch for Employee</SelectItem>}
          {isAdmin && <SelectItem value="/admin/exports">Exports</SelectItem>}
          {canViewReports && <SelectItem value="/admin/corrections">Punch corrections</SelectItem>}
          {isAdmin && <SelectItem value="/admin/data">Data Management</SelectItem>}
          {isAdmin && <SelectItem value="/admin/users">Employee & Contractor Management</SelectItem>}
          {isAdmin && <SelectItem value="/admin/invite">Invite Subcontractor</SelectItem>}
          {isAdmin && <SelectItem value="/admin/maintenance">Maintenance Banner</SelectItem>}
        </SelectContent>
      </SelectTrigger>
    </Select>
  );
}
